"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const bind_decorator_1 = require("bind-decorator");
const i18next_1 = __importDefault(require("i18next"));
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const react_toastify_1 = require("react-toastify");
const activities_1 = require("../../api/activities");
const Button_1 = __importDefault(require("../../common/js/atoms/Button"));
const Icon_1 = __importDefault(require("../../common/js/atoms/Icon"));
const NativeSelect_1 = __importDefault(require("../../common/js/atoms/NativeSelect"));
const LoadingSpinner_1 = __importStar(require("../../common/js/components/LoadingSpinner"));
const ButtonVariant_1 = __importDefault(require("../../common/js/enums/ButtonVariant"));
const Zupicons_1 = __importDefault(require("../../common/js/enums/Zupicons"));
const license_1 = require("../../common/js/helper/license");
const translation_1 = require("../../common/js/helper/translation");
const product_1 = require("../helper/product");
const Activities_1 = __importDefault(require("../stores/Activities"));
const ContactPersonStore_1 = __importDefault(require("../stores/ContactPersonStore"));
const LicenseStore_1 = __importDefault(require("../stores/LicenseStore"));
class ChangeLicenseContactModal extends react_1.default.Component {
    contacts = [];
    isLoading = false;
    isSubmitting = false;
    customerId = null;
    constructor(props) {
        super(props);
        (0, mobx_1.makeObservable)(this, {
            contacts: mobx_1.observable,
            customerId: mobx_1.observable,
            isLoading: mobx_1.observable,
            isSubmitting: mobx_1.observable,
        });
    }
    componentDidMount() {
        (0, mobx_1.runInAction)(() => this.loadContacts());
    }
    loadContacts() {
        this.isLoading = true;
        ContactPersonStore_1.default.loadContactPersons()
            .then((0, mobx_1.action)((customers) => {
            this.contacts = [...customers.entries()]
                .filter((customerEntry) => {
                const timePassedSinceCreated = Date.now() -
                    (customerEntry[1].extensions?.massiveCustomer?.createdAt.getTime() ?? Date.now());
                return timePassedSinceCreated >= 1000 * 60 * 5;
            })
                .map(([customerId, customer]) => ({
                label: `${customer.firstName} ${customer.lastName}`,
                value: customerId,
            }))
                .sort((a, b) => Intl.Collator(i18next_1.default.language).compare(a.label, b.label));
            const { licenseContactId } = this.props.data;
            if (licenseContactId) {
                this.customerId = ContactPersonStore_1.default.findCustomerByExternalId(licenseContactId)?.id ?? null;
            }
        }))
            .finally((0, mobx_1.action)(() => {
            this.isLoading = false;
        }));
    }
    render() {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: "modal-header znd-modal__header" },
                react_1.default.createElement("h3", { className: "znd-modal__title" }, (0, translation_1.t)('modal.software_edit_license_contact.title')),
                react_1.default.createElement("div", { className: "znd-modal__close", onClick: this.props.onCancel },
                    react_1.default.createElement(Icon_1.default, { name: Zupicons_1.default.close }))),
            react_1.default.createElement("form", { onSubmit: this.onSubmit },
                react_1.default.createElement("div", { className: "modal-body znd-modal__body" },
                    react_1.default.createElement("h3", { className: "t-body-small znd-change-contact-modal__label" }, (0, translation_1.t)('modal.software_edit_license_contact.license_label')),
                    react_1.default.createElement("p", null, `${this.props.data.name ?? ''} - ${this.props.externalId}`),
                    react_1.default.createElement("h3", { className: "t-body-small znd-change-contact-modal__label" }, (0, translation_1.t)('modal.software_edit_license_contact.contact.label')),
                    this.isLoading === null ? (react_1.default.createElement("div", { className: "form-control-plaintext my-1" },
                        react_1.default.createElement(LoadingSpinner_1.default, { style: LoadingSpinner_1.LoadingSpinnerStyle.small }))) : (react_1.default.createElement(NativeSelect_1.default, { key: "licenseContactId", onChange: (0, mobx_1.action)((value) => {
                            this.customerId = value;
                        }), options: this.contacts, placeholder: (0, translation_1.t)('modal.software_edit_license_contact.contact.placeholder'), required: true, value: this.customerId ?? '', disabled: this.isLoading || this.isSubmitting, noOptionPreselected: !this.customerId })),
                    react_1.default.createElement("div", { className: "znd-change-contact-modal__info" }, (0, translation_1.t)('modal.software_edit_license_contact.contact.info'))),
                react_1.default.createElement("div", { className: "modal-footer znd-modal__footer" },
                    react_1.default.createElement(Button_1.default, { className: "justify-content-center", onClick: this.props.onCancel, text: (0, translation_1.t)('modal.software_edit_license_contact.cancel'), variant: ButtonVariant_1.default.secondary, disabled: this.isLoading || this.isSubmitting }),
                    react_1.default.createElement(Button_1.default, { className: "justify-content-center", disabled: this.isLoading || this.isSubmitting || !this.customerId, text: (0, translation_1.t)('modal.software_edit_license_contact.submit'), type: 'submit', variant: ButtonVariant_1.default.primary })))));
    }
    onSubmit(event) {
        event.preventDefault();
        if (null === this.customerId) {
            return;
        }
        this.isSubmitting = true;
        LicenseStore_1.default.updateLicenseContactId(this.props.data.id, this.customerId)
            .then(() => {
            const newLicenseContactId = ContactPersonStore_1.default.getLicenseContactId(this.customerId ?? '') ?? '';
            Activities_1.default.save({
                ...(0, license_1.licenseActivity)(activities_1.ActivityTopic.ContactPersonChange, this.props.data),
                data: {
                    fromContactId: this.props.data.licenseContactId,
                    toContactId: newLicenseContactId,
                },
            });
            (0, product_1.updateContactId)(this.props.data.id, newLicenseContactId);
            const customer = ContactPersonStore_1.default.customerList.find((currentCustomer) => this.customerId === currentCustomer.id);
            if (customer) {
                (0, product_1.updateContactName)(this.props.data.id, customer);
            }
            LicenseStore_1.default.triggerObservables();
            react_toastify_1.toast.success((0, translation_1.t)('modal.software_edit_license_contact.send_success'));
            this.props.onDone();
        })
            .catch(() => {
            react_toastify_1.toast.error((0, translation_1.t)('modal.software_edit_license_contact.send_error'));
        })
            .finally(() => {
            this.isSubmitting = false;
        });
    }
}
__decorate([
    bind_decorator_1.bind
], ChangeLicenseContactModal.prototype, "onSubmit", null);
exports.default = (0, react_i18next_1.withTranslation)()((0, mobx_react_1.observer)(ChangeLicenseContactModal));
